import { Question } from "@/types/test";
import { QuestionPreview } from "../question-preview/QuestionPreview";

interface QuestionSelectionListProps {
  questions: Question[];
  selectedQuestions: Set<number>;
  onToggleQuestion: (index: number) => void;
}

export const QuestionSelectionList = ({
  questions,
  selectedQuestions,
  onToggleQuestion,
}: QuestionSelectionListProps) => {
  return (
    <div className="space-y-4">
      {questions.map((question, index) => (
        <QuestionPreview
          key={index}
          question={question}
          isSelected={selectedQuestions.has(index)}
          onToggle={() => onToggleQuestion(index)}
        />
      ))}
    </div>
  );
};